import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../service/getNumberOfLayers"
import { isFlexible, isMetal, isRigid } from "../../../../service/oneClickIs"
import type EstimateValues from "../../../../types/params"
import getNumberOfMinPattern from "../../getNumberOfMinPattern"

const replaceBeatenThickness = (values: EstimateValues) => {
  const isDisplayed = getDisplayCondition(values)
  const numberOfMinPattern = getNumberOfMinPattern(values)
  const numberOfLayers = getNumberOfLayers(values)

  if (isDisplayed.beatenThickness) {
    switch (values.beatenThickness) {
      case ESTIMATE_CONSTANT.銅箔厚み["18μm(リジッド)"].value:
      case ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm未満)"].value:
      case ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm以上__片面)"].value:
      case ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm以上__2層)"].value:
        if (isRigid(values)) return ESTIMATE_CONSTANT.銅箔厚み["18μm(リジッド)"].value
        if (isFlexible(values)) {
          if (numberOfMinPattern < 0.1) return ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm未満)"].value
          if (numberOfMinPattern >= 0.1 && numberOfLayers === 1)
            return ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm以上__片面)"].value
          if (numberOfMinPattern >= 0.1 && numberOfLayers === 2)
            return ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm以上__2層)"].value
        }
        break

      case ESTIMATE_CONSTANT.銅箔厚み["35μm(リジッド)"].value:
      case ESTIMATE_CONSTANT.銅箔厚み["35μm(フレキシブル__片面)"].value:
      case ESTIMATE_CONSTANT.銅箔厚み["35μm(フレキシブル__2層)"].value:
      case ESTIMATE_CONSTANT.銅箔厚み["35μm(メタル)"].value:
        if (isRigid(values)) return ESTIMATE_CONSTANT.銅箔厚み["35μm(リジッド)"].value
        if (isFlexible(values) && numberOfLayers === 1)
          return ESTIMATE_CONSTANT.銅箔厚み["35μm(フレキシブル__片面)"].value
        if (isFlexible(values) && numberOfLayers === 2)
          return ESTIMATE_CONSTANT.銅箔厚み["35μm(フレキシブル__2層)"].value
        if (isMetal(values)) return ESTIMATE_CONSTANT.銅箔厚み["35μm(メタル)"].value
        break

      case ESTIMATE_CONSTANT.銅箔厚み["70μm(リジッド)"].value:
      case ESTIMATE_CONSTANT.銅箔厚み["70μm(メタル)"].value:
        if (isRigid(values)) return ESTIMATE_CONSTANT.銅箔厚み["70μm(リジッド)"].value
        if (isMetal(values)) return ESTIMATE_CONSTANT.銅箔厚み["70μm(メタル)"].value
        break

      case ESTIMATE_CONSTANT.銅箔厚み["内層18μm外層18μm(リジッド)"].value:
      case ESTIMATE_CONSTANT.銅箔厚み["内層18μm外層18μm(フレキシブル)"].value:
        if (isRigid(values)) return ESTIMATE_CONSTANT.銅箔厚み["内層18μm外層18μm(リジッド)"].value
        if (isFlexible(values)) return ESTIMATE_CONSTANT.銅箔厚み["内層18μm外層18μm(フレキシブル)"].value
        break
    }
  }

  return values.beatenThickness
}

export default replaceBeatenThickness
